<template>
  <div
    class="calendar-content-axis-x"
    :data-zoom-level="zoom"
    :data-days="daysCount"
    :data-weekends="getWeekends">
    <span
      v-for="(line, index) of lines"
      :key="'calendar-content-axis-x-line-' + index"
      :data-line="index + 1"
      class="calendar-content-axis-x-line"></span>

    <span
      v-for="(dayNumber, index) of getWeekends.saturdays"
      :key="'calendar-content-axis-weekend-bar-sat-' + index"
      :style="'--day-number: ' + dayNumber + ';'"
      class="calendar-content-axis-x-weekend-bar is-saturday"></span>

    <span
      v-for="(dayNumber, index) of getWeekends.sundays"
      :key="'calendar-content-axis-weekend-bar-sun-' + index"
      :style="'--day-number: ' + dayNumber + ';'"
      class="calendar-content-axis-x-weekend-bar is-sunday"></span>
  </div>
</template>

<script>
export default {
  name: 'calendar-axis-x',
  props: [
    'zoom',
    'daysCount',
    'dateFrom',
    'dateTo'
  ],
  computed: {
    lines () {
      switch (this.zoom) {
        case '1':
        case '2':
        case '4':
          return [...Array(47).keys()];
        case '7':
        case '14':
          return [...Array(41).keys()];
        case '30':
        case '60':
          return [...Array(this.daysCount - 1).keys()];
        default:
          return [];
      }
    },
    getWeekends() {
      let start = new Date(this.dateFrom);
      let end = new Date(this.dateTo);
      end.setDate(end.getDate() - 1);
      let saturdays = [];
      let sundays = [];
      let index = 0;

      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        if (d.getDay() === 6) {
          saturdays.push(index);
        } else if (d.getDay() === 0) {
          sundays.push(index);
        }

        index++;
      }

      return { saturdays, sundays };
    }
  }
}
</script>

<style lang="scss" scoped>
.calendar-content {
  &-axis-x {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;

    &-line {
      border-left: 1px solid #aaa;
      height: 100%;
      position: absolute;
      top: 0;
      width: 0;
    }

    &[data-zoom-level="1"],
    &[data-zoom-level="2"],
    &[data-zoom-level="4"] {
      .calendar-content-axis-x-line:nth-child(2n + 1) {
        border-left-style: dashed;
      }

      .calendar-content-axis-x-line {
        @for $i from 1 through 47 {
          &[data-line="#{$i}"] {
            left: $i * (100% / 48);
          }
        }
      }
    }

    &[data-zoom-level="2"] {
      .calendar-content-axis-x-line:nth-child(24) {
        border-left: 2px solid #aaa;
      }
    }

    &[data-zoom-level="4"] {
      .calendar-content-axis-x-line:nth-child(12),
      .calendar-content-axis-x-line:nth-child(24),
      .calendar-content-axis-x-line:nth-child(36) {
        border-left: 2px solid #aaa;
      }
    }

    &[data-zoom-level="7"],
    &[data-zoom-level="14"] {
      .calendar-content-axis-x-line {
        @for $i from 1 through 41 {
          &[data-line="#{$i}"] {
            left: $i * (100% / 42);
          }
        }
      }
    }

    &[data-zoom-level="30"][data-days="28"] {
      .calendar-content-axis-x-line {
        @for $i from 1 through 28 {
          &[data-line="#{$i}"] {
            left: $i * (100% / 28);
          }
        }
      }
    }

    &[data-zoom-level="30"][data-days="29"] {
      .calendar-content-axis-x-line {
        @for $i from 1 through 29 {
          &[data-line="#{$i}"] {
            left: $i * (100% / 29);
          }
        }
      }
    }

    &[data-zoom-level="30"][data-days="30"] {
      .calendar-content-axis-x-line {
        @for $i from 1 through 30 {
          &[data-line="#{$i}"] {
            left: $i * (100% / 30);
          }
        }
      }
    }

    &[data-zoom-level="30"][data-days="31"] {
      .calendar-content-axis-x-line {
        @for $i from 1 through 31 {
          &[data-line="#{$i}"] {
            left: $i * (100% / 31);
          }
        }
      }
    }

    &[data-zoom-level="60"][data-days="59"] {
     .calendar-content-axis-x-line {
        @for $i from 1 through 59 {
          &[data-line="#{$i}"] {
            left: $i * (100% / 59);
          }
        }
      }
    }

    &[data-zoom-level="60"][data-days="60"] {
      .calendar-content-axis-x-line {
        @for $i from 1 through 60 {
          &[data-line="#{$i}"] {
            left: $i * (100% / 60);
          }
        }
      }
    }

    &[data-zoom-level="60"][data-days="61"] {
      .calendar-content-axis-x-line {
        @for $i from 1 through 61 {
          &[data-line="#{$i}"] {
            left: $i * (100% / 61);
          }
        }
      }
    }

    &[data-zoom-level="60"][data-days="62"] {
      .calendar-content-axis-x-line {
        @for $i from 1 through 62 {
          &[data-line="#{$i}"] {
            left: $i * (100% / 62);
          }
        }
      }
    }

    &[data-zoom-level="7"] {
      .calendar-content-axis-x-line:nth-child(6),
      .calendar-content-axis-x-line:nth-child(12),
      .calendar-content-axis-x-line:nth-child(18),
      .calendar-content-axis-x-line:nth-child(24),
      .calendar-content-axis-x-line:nth-child(30),
      .calendar-content-axis-x-line:nth-child(36) {
        border-left: 2px solid #aaa;
      }
    }

    &[data-zoom-level="14"] {
      .calendar-content-axis-x-line:nth-child(3),
      .calendar-content-axis-x-line:nth-child(6),
      .calendar-content-axis-x-line:nth-child(9),
      .calendar-content-axis-x-line:nth-child(12),
      .calendar-content-axis-x-line:nth-child(15),
      .calendar-content-axis-x-line:nth-child(18),
      .calendar-content-axis-x-line:nth-child(21),
      .calendar-content-axis-x-line:nth-child(24),
      .calendar-content-axis-x-line:nth-child(27),
      .calendar-content-axis-x-line:nth-child(30),
      .calendar-content-axis-x-line:nth-child(33),
      .calendar-content-axis-x-line:nth-child(36),
      .calendar-content-axis-x-line:nth-child(39) {
        border-left: 2px solid #aaa;
      }
    }

    &[data-zoom-level="30"] {
      .calendar-content-axis-x-line:nth-child(4),
      .calendar-content-axis-x-line:nth-child(8),
      .calendar-content-axis-x-line:nth-child(12),
      .calendar-content-axis-x-line:nth-child(16),
      .calendar-content-axis-x-line:nth-child(20),
      .calendar-content-axis-x-line:nth-child(24),
      .calendar-content-axis-x-line:nth-child(28) {
        border-left: 2px solid #aaa;
      }
    }

    &[data-zoom-level="60"] {
      .calendar-content-axis-x-line:nth-child(8),
      .calendar-content-axis-x-line:nth-child(16),
      .calendar-content-axis-x-line:nth-child(24),
      .calendar-content-axis-x-line:nth-child(32),
      .calendar-content-axis-x-line:nth-child(40),
      .calendar-content-axis-x-line:nth-child(48),
      .calendar-content-axis-x-line:nth-child(56) {
        border-left: 2px solid #aaa;
      }
    }

    // weekend bars
    &-weekend-bar {
      background: rgba(255, 252, 187, .33);
      height: 100%;
      position: absolute;
      pointer-events: none;
      top: 0;
    }

    &[data-zoom-level="1"] {
      .calendar-content-axis-x-weekend-bar {
        left: 0;
        width: 100%;
      }
    }

    &[data-zoom-level="2"] {
      .calendar-content-axis-x-weekend-bar {
        left: calc(var(--day-number) * 50%);
        width: 50%;
      }
    }

    &[data-zoom-level="4"] {
      .calendar-content-axis-x-weekend-bar {
        left: calc(var(--day-number) * 25%);
        width: 25%;
      }
    }

    &[data-zoom-level="7"] {
      .calendar-content-axis-x-weekend-bar {
        left: calc(var(--day-number) * (100% / 7));
        width: calc(100% / 7);
      }
    }

    &[data-zoom-level="14"] {
      .calendar-content-axis-x-weekend-bar {
        left: calc(var(--day-number) * (100% / 14));
        width: calc(100% / 14);
      }
    }

    &[data-zoom-level="30"][data-days="28"] {
      .calendar-content-axis-x-weekend-bar {
        left: calc(var(--day-number) * (100% / 28));
        width: calc(100% / 28);
      }
    }

    &[data-zoom-level="30"][data-days="29"] {
      .calendar-content-axis-x-weekend-bar {
        left: calc(var(--day-number) * (100% / 29));
        width: calc(100% / 29);
      }
    }

    &[data-zoom-level="30"][data-days="30"] {
      .calendar-content-axis-x-weekend-bar {
        left: calc(var(--day-number) * (100% / 30));
        width: calc(100% / 30);
      }
    }

    &[data-zoom-level="30"][data-days="31"] {
      .calendar-content-axis-x-weekend-bar {
        left: calc(var(--day-number) * (100% / 31));
        width: calc(100% / 31);
      }
    }

    &[data-zoom-level="60"][data-days="59"] {
      .calendar-content-axis-x-weekend-bar {
        left: calc(var(--day-number) * (100% / 59));
        width: calc(100% / 59);
      }
    }

    &[data-zoom-level="60"][data-days="60"] {
      .calendar-content-axis-x-weekend-bar {
        left: calc(var(--day-number) * (100% / 60));
        width: calc(100% / 60);
      }
    }

    &[data-zoom-level="60"][data-days="61"] {
      .calendar-content-axis-x-weekend-bar {
        left: calc(var(--day-number) * (100% / 61));
        width: calc(100% / 61);
      }
    }

    &[data-zoom-level="60"][data-days="62"] {
      .calendar-content-axis-x-weekend-bar {
        left: calc(var(--day-number) * (100% / 62));
        width: calc(100% / 62);
      }
    }
  }
}
</style>
